import React, { ReactNode } from 'react';
import Footer from './Footer';

const MainFooterContainer = ({ children }: { children?: ReactNode }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="h-full max-h-full flex-1">{children}</div>
      <Footer className="mb-0 pb-4" />
    </div>
  );
};

export default MainFooterContainer;
